import { useRef, useCallback, useMemo } from "react";

export function useSectionScroll() {
  const pourquoi = useRef(null);
  const comment = useRef(null);
  const faq = useRef(null);
  const inscrire = useRef(null);

  const refs = useMemo(
    () => ({ pourquoi, comment, faq, inscrire }),
    [pourquoi, comment, faq, inscrire]
  );

  const scrollTo = useCallback((sectionId) => {
    const ref = refs[sectionId];
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [refs]);

  return { refs, scrollTo };
}
